module.exports = __webpack_public_path__ + "static/media/zfh.62fc88f6.png";